export const language = "EN";
